module.exports = require("./nb-NO");